var sachsenAnhaltQuestions = [
  {
    id: '301',
    question: 'Welches Wappen gehört zum Bundesland Sachsen-Anhalt?',
    image: '431',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 1,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '302',
    question: 'Welches ist ein Landkreis in Sachsen-Anhalt?',
    answers: [
      {
        content: 'Ammerland',
        key: 0,
      },
      {
        content: 'Altötting',
        key: 0,
      },
      {
        content: 'Uckermark',
        key: 0,
      },
      {
        content: 'Börde',
        key: 1,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '303',
    question: 'Für wie viele Jahre wird der Landtag in Sachsen-Anhalt gewählt?',
    answers: [
      {
        content: '3',
        key: 0,
      },
      {
        content: '4',
        key: 0,
      },
      {
        content: '5',
        key: 1,
      },
      {
        content: '6',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '304',
    question: 'Ab welchem Alter darf man in Sachsen-Anhalt bei Kommunalwahlen wählen?',
    answers: [
      {
        content: '14',
        key: 0,
      },
      {
        content: '16',
        key: 1,
      },
      {
        content: '18',
        key: 0,
      },
      {
        content: '20',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '305',
    question: 'Welche Farben hat die Landesflagge von Sachsen-Anhalt?',
    answers: [
      {
        content: 'blau-weiß-rot',
        key: 0,
      },
      {
        content: 'gelb-schwarz',
        key: 1,
      },
      {
        content: 'grün-weiß-rot',
        key: 0,
      },
      {
        content: 'weiß-rot',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '306',
    question: 'Wo können Sie sich in Sachsen-Anhalt über politische Themen informieren?',
    answers: [
      {
        content: 'bei den Kirchen',
        key: 0,
      },
      {
        content: 'bei der Landeszentrale für politische Bildung',
        key: 1,
      },
      {
        content: 'beim Ordnungsamt der Gemeinde',
        key: 0,
      },
      {
        content: 'bei der Verbraucherzentrale',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '307',
    question: 'Die Landeshauptstadt von Sachsen-Anhalt heißt...',
    answers: [
      {
        content: 'Halle.',
        key: 0,
      },
      {
        content: 'Dessau.',
        key: 0,
      },
      {
        content: 'Magdeburg.',
        key: 1,
      },
      {
        content: 'Wittenberg.',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '308',
    question: 'Welches Bundesland ist Sachsen-Anhalt?',
    image: '438',
    answers: [
      {
        content: '1',
        key: 0,
      },
      {
        content: '2',
        key: 0,
      },
      {
        content: '3',
        key: 1,
      },
      {
        content: '4',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '309',
    question: 'Wie nennt man den Regierungschef / die Regierungschefin in Sachsen-Anhalt?',
    answers: [
      {
        content: 'Erster Minister / Erste Ministerin',
        key: 0,
      },
      {
        content: 'Premierminister / Premierministerin',
        key: 0,
      },
      {
        content: 'Bürgermeister / Bürgermeisterin',
        key: 0,
      },
      {
        content: 'Ministerpräsident / Ministerpräsidentin',
        key: 1,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
  {
    id: '310',
    question: 'Welchen Minister / welche Ministerin hat Sachsen-Anhalt nicht?',
    answers: [
      {
        content: 'Justizminister / Justizministerin',
        key: 0,
      },
      {
        content: 'Außenminister / Außenministerin',
        key: 1,
      },
      {
        content: 'Finanzminister / Finanzministerin',
        key: 0,
      },
      {
        content: 'Innenminister / Innenministerin',
        key: 0,
      },
    ],
    category: 'Sachsen-Anhalt',
  },
]

export default sachsenAnhaltQuestions
